import { NavLink } from "react-router-dom"
import { useTranslation } from "react-i18next";
import { MDBBtn, MDBIcon, MDBTypography } from "mdb-react-ui-kit";
import { useCallback, useMemo, useState } from "react";


export interface ProfileBarProps {
    profile: any;
    mobile: boolean;
}
export const ProfileBar = ({profile, mobile}: ProfileBarProps) => {
    const { t } = useTranslation();

    const [shown, setShown] = useState(mobile ? false : true);
    const [backdrop, setBackgroup] = useState(false);

    const toggle = useCallback(() => {
        if (!shown){
            if (mobile) setBackgroup(true);
            setShown(true);
        }else {
            if (mobile) setTimeout(() => setBackgroup(false), 500);
            setShown(false);
        }
    }, [shown, mobile]);

    const onTabClick = useCallback(tab => {
        if (mobile && shown) toggle();
    }, [mobile && shown]);

    const tabs = useMemo<{name: string|React.ReactNode, icon: string, location: string}[]>(() => ([
        { name: (
            <div className="d-flex flex-row align-items-center">
                {/* <MDBIcon icon="user-circle" size="2x" className="me-1"/> */}
                <div className="d-flex flex-column w-100 overflow-hidden" style={{lineHeight: '1.1rem'}}>
                    <span className="overflow-hidden" style={{whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}>{profile.name}</span>
                    <span className="text-muted overflow-hidden" style={{fontSize: '80%', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}>{profile.company?.name}</span>
                </div>
            </div>
        ), icon: 'user-alt', location: "" },
        ...( profile.permissions?.SubcompanyView ? [{ name: t('companies'), icon: 'building', location: 'companies' }] : []),
        ...( profile.permissions?.UserView ? [{ name: t('users'), icon: 'users', location: 'users' }] : []),
        ...( profile.permissions?.RightsView ? [{ name: t('permissions'), icon: 'briefcase', location: 'permissions' }] : []),
        ...( profile.permissions?.GroupView ? [{ name: t('groups'), icon: 'layer-group', location: 'groups' }] : []),
        ...( profile.permissions?.LocationView ? [{ name: t('locations'), icon: 'map-marker-alt', location: 'locations' }] : []),
        ...( profile.permissions?.ProductView ? [{ name: t('products'), icon: 'shopping-cart', location: 'products' }] : []),
        ...( profile.permissions?.MachineView ? [{ name: t('machines'), icon: 'server', location: 'machines' }] : []),
        // ...( profile.permissions?.Dev ? [{ name: t('developer_options'), icon: 'code', location: 'dev' }] : []),
    ]), [profile]);


    return (
        <>
            { !shown &&
                <div className="position-absolute p-2" onClick={toggle}>
                    <MDBBtn color="link" className="p-2"><MDBIcon icon="bars" color="dark" size="2x"/></MDBBtn>
                </div>
            }
            { backdrop && (
                <div className={`modal-backdrop fade ${shown ? 'show' : ''}`} style={{zIndex: 2000}} onClick={shown ? toggle : undefined}></div>
            )}
            <section
                className={"d-flex flex-column overflow-hidden pe-2 h-100" + (!mobile ? '' : " position-absolute")}
                style={{
                    width: !shown ? (mobile ? 0 : 0) : (mobile ? '80%' : 250),
                    transition: '0.5s',
                    marginLeft: !shown ? -20 : 0,
                    left: mobile ? 0 : undefined,
                    top: mobile ? 0 : undefined,
                    zIndex: mobile ? 2001 : undefined
                }}
            >
                <nav id="sidebarMenu" className="d-lg-block sidebar bg-white flex-fill h-100">
                    <div className="h-100">
                        <div className={"list-group list-group-flush h-100 p-2"}>
                            <div className="d-flex flex-row mb-1" onClick={toggle}>
                                <MDBBtn color="link" className="p-2"><MDBIcon icon="bars" color="dark" size="2x"/></MDBBtn>
                                <div className="d-flex flex-fill"></div>
                                <NavLink to={'/'}>
                                    <span role="button" className="nav-link d-flex align-items-center p-1 user-select-none cursor-pointer" style={{cursor: 'pointer'}}>
                                        <div className="d-flex align-items-center pe-1">
                                            <img src={`/logo.png`} style={{width: 28, height: 28}}/>
                                        </div>
                                    </span>
                                </NavLink>
                            </div>
                            {tabs.map(tab => (
                                <SideNavItem key={tab.location} name={tab.name} icon={tab.icon} location={tab.location} onClick={() => onTabClick(tab)}/>
                            ))}
                        </div>
                    </div>
                </nav>
            </section>
        </>
    )
}

const SideNavItem = ({name, icon, location, onClick}: {
    name: string|React.ReactNode;
    icon: string;
    location: string;
    onClick?: () => void;
}) => (
    <NavLink
        end to={location}
        className={({isActive}) => "d-flex align-items-center list-group-item " + (isActive ? ' active':'')} style={{flexWrap: "nowrap"}}
        onClick={onClick}
    >
        <MDBIcon icon={icon} fixed/>
        { typeof name == 'string' && <span className="ms-2" style={{whiteSpace: 'nowrap', textOverflow: "clip", overflow: 'hidden'}}>{name}</span> }
        { typeof name !== 'string' && (
            <div className="ms-2 overflow-hidden">
                {name}
            </div>
        ) }
    </NavLink>
)